import React from "react";
import ComplexPicker from "..";
import { IItemData } from "../common.typing";
import locale from "../../../_util/locale";

export interface IOrgPickerProps {
    /** 组件的标题 */
    title?: string;
    /** 是否为多选 */
    multiple?: boolean;
    /** 数量超出时的提示 */
    limitTips?: string;
    /** 可选的最大数量 */
    maxNum?: number;
    /** 不可用 org id */
    disabledids?: string[];
    /** 已选择的 org */
    pickedList?: IItemData[];
    /** 必须选择的 org */
    requiredList?: IItemData[];
    /** 根据部门 id 获取组织架构信息 */
    getOrgList: (obj?: IItemData) => void;
    /** 组织架构展开信息 */
    orgList: IItemData[];
    /** 组织架构下的成员 */
    orgUser: IItemData[];
    /** 组织架构面包屑 */
    orgBread?: IItemData[];
    /** 关闭组件方法 */
    onClose: () => void;
    /** 点击确定 */
    onConfirm: (ids: string[], length: number) => void;
    /** 是否展示确认按钮的数量 */
    showSelectedNum?: boolean;
    /** 确认按钮是否为 loading 态 */
    isConfirmLoading?: boolean;
    getPersonOrg?: () => void;
    /** 个人组织架构信息 */
    personOrg?: IItemData;

    /** 可选总数为 0 时确认按钮可点击，默认为 false */
    canSelectZero?: boolean;
    /** 搜索预留内容区域 */
    mainChildren?: React.ReactNode;
    /** 是否只展示选中的数量,不显示最大数量 */
    justShowSelectedNoMax?: boolean;
    /** 是否禁用标题拖拽 */
    isDisableTitleDrag?: boolean;
    /** 埋点方法 */
    track: (eventName: string, eventData?: any) => void;
}

/**
 * 选择组织架构
 */
export const OrgPicker: React.FC<IOrgPickerProps> = ({
    onClose,
    onConfirm,
    title = locale("orgPickerTitleDefault"),
    multiple = true,
    limitTips = locale("common_select_overrun"),
    maxNum = 1,
    disabledids,
    pickedList,
    requiredList,
    getOrgList,
    orgList,
    orgUser,
    orgBread,
    showSelectedNum = true,
    isConfirmLoading = false,
    getPersonOrg,
    personOrg,
    canSelectZero = false,
    mainChildren,
    justShowSelectedNoMax = false,
    isDisableTitleDrag,
    track,
}) => {
    const userPickerProps = {
        type: "org",
        page: "home",
        authority: "all",
        showGroups: false,
        showRecentSession: false,
        showPartner: false,
        onClose,
        onConfirm,
        title,
        multiple,
        limitTips,
        maxNum,
        disabledids,
        pickedList,
        requiredList,
        getOrgList,
        orgList,
        orgUser,
        orgBread,
        showSelectedNum,
        isConfirmLoading,
        getPersonOrg,
        personOrg,
        canSelectZero,
        mainChildren,
        justShowSelectedNoMax,
        isDisableTitleDrag,
        track,
    };
    return <ComplexPicker {...userPickerProps} />;
};

export default OrgPicker;
